import React from 'react';
import { Form, Modal, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useUpdateExpenseStatus } from 'api/expenses/use-update-expense-status.ts';
import { ExpenseStatuses } from 'types/expense-status';
import type { IExpenseStatusEditModalProps, IExpenseStatusFormFields } from './types';

export const ExpenseStatusEditModal: React.FC<IExpenseStatusEditModalProps> = (props) => {
  const { isOpen, onClose, currentStatus, expenseId } = props;

  const { mutateAsync: updateExpenseStatus, isLoading } = useUpdateExpenseStatus(expenseId);

  const [form] = Form.useForm();
  const selectedStatus = Form.useWatch('status', form);
  const isUnchanged = !selectedStatus || selectedStatus === currentStatus;

  const handleOk = debounce(() => form.submit(), 200);

  const onFinish = async (values: IExpenseStatusFormFields) => {
    await updateExpenseStatus(values);
    onClose();
  };

  return (
    <Modal
      title='Edit status'
      open={isOpen}
      confirmLoading={isLoading}
      okButtonProps={{ disabled: isUnchanged }}
      onCancel={onClose}
      onOk={handleOk}>
      <Form
        form={form}
        name='expense_status'
        layout='vertical'
        initialValues={currentStatus ? { status: currentStatus } : undefined}
        onFinish={onFinish}>
        <Form.Item name='status' rules={[{ required: true, type: 'string' }]}>
          <Select
            options={ExpenseStatuses.map((status) => ({
              label: status,
              value: status,
              disabled: status === currentStatus,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
